import React, { useState, useContext } from "react";
import styled from "styled-components";
import { ThemeContext } from "styled-components";
import avatarWalkthroughs from "./data/avatar-walkthroughs";
import avatarAppVideos from "./data/avatar-app-videos";
import avatarPortalVideos from "./data/avatar-portal-videos";
import avatarBestPractices from "./data/avatar-best-practices";
import avatarEducation from "./data/avatar-education";
import fbbcWalkthroughs from "./data/fbbc-walkthroughs";
import fbbcPortalVideos from "./data/fbbc-portal-videos";
import fbbcAppVideos from "./data/fbbc-app-videos";
import fbbcEducation from "./data/fbbc-education";
import fbbcBestPractices from "./data/fbbc-best-practices";
import List from "./list";
import VideoPlayer from "./video-player";
import Input from "../../../../components/input";

const Page = styled.div``;

const Content = styled.div`
  padding: 60px 0 200px 0;
  margin: 0 auto;
`;

const SearchWrapper = styled.div`
  padding: 0 12px;
  margin-bottom: 24px;
  max-width: 520px;
`;

const NoResults = styled.p`
  color: #555;
  font-size: 0.95rem;
  margin: 8px 12px 0;
`;

function Videos() {
  const theme = useContext(ThemeContext);
  const [showVideo, setShowVideo] = useState(false);
  const [video, setVideo] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  const handleVideoClick = (data) => {
    setShowVideo(true);
    setVideo(data);
  };

  const categories =
    theme.name === "AVATAR"
      ? [
          {
            large: true,
            title: "Walkthroughs",
            data: avatarWalkthroughs,
          },
          {
            title: "Avatar Portal",
            data: avatarPortalVideos,
          },
          {
            title: "Avatar App",
            data: avatarAppVideos,
          },
          {
            title: "Avatar Nutrition Best Practices",
            data: avatarBestPractices,
          },
          {
            title: "Nutrition Education",
            data: avatarEducation,
          },
        ]
      : [
          {
            large: true,
            title: "Walkthrough",
            data: fbbcWalkthroughs,
          },
          {
            title: "Fit Body Coaching Portal",
            data: fbbcPortalVideos,
          },
          {
            title: "Fit Body Nutrition App",
            data: fbbcAppVideos,
          },
          {
            title: "Fit Body Nutrition Education",
            data: fbbcEducation,
          },
          {
            title: "Fit Body Nutrition Best Practices",
            data: fbbcBestPractices,
          },
        ];

  const filteredCategories = categories
    .map((category) => ({
      ...category,
      data: normalizedSearchTerm
        ? category.data.filter((video) =>
            video.title.toLowerCase().includes(normalizedSearchTerm)
          )
        : category.data,
    }))
    .filter((category) => category.data.length > 0);

  return (
    <Page>
      <Content>
        <SearchWrapper>
          <Input
            label="Search Videos"
            name="video-search"
            placeholder="Search by video name"
            value={searchTerm}
            onChange={setSearchTerm}
            type="search"
          />
        </SearchWrapper>
        {filteredCategories.map((category) => (
          <List
            key={`${category.title}-${normalizedSearchTerm}`}
            large={category.large}
            title={category.title}
            data={category.data}
            handleVideoClick={handleVideoClick}
          />
        ))}
        {normalizedSearchTerm && filteredCategories.length === 0 && (
          <NoResults>No videos found.</NoResults>
        )}
      </Content>
      <VideoPlayer
        video={video}
        open={showVideo}
        onClose={() => setShowVideo(false)}
      />
    </Page>
  );
}

export default Videos;
